










































import {Component, Prop, Vue} from 'vue-property-decorator'
import RadioButton from "@/components/UI/RadioButton.vue";
import ImageUploader from "@/components/UI/ImageUploader.vue";
import Toggle from "@/components/UI/Toggle.vue";
import ColorSelector from "@/components/UI/ColorSelector.vue";
import RadioImageButton from '@/components/UI/RadioImageButton.vue'
import ToggleCheckBox from '@/components/UI/ToggleCheckBox.vue'

@Component({
    components: {
        RadioButton,
        RadioImageButton,
        ImageUploader,
        Toggle,
        ToggleCheckBox,
        ColorSelector,
    },
})
export default class SettingOptionUI extends Vue {
    @Prop() private option!: CMS.SettingOption;
    @Prop() private value!: string | boolean;

    get optionStringValue(): string {
        // 設定済みならそれを返す
        if (this.value)
            return this.value as string;

        // 未設定ならデフォルト値を返す
        return this.option.default || "";
    }

    get optionBoolValue(): boolean {
        // 設定済みならそれを返す true以外はfalse
        if (this.value != null)
            return this.value as boolean;

        // 未設定ならデフォルト値を返す
        return this.option.default as boolean || false;
    }
}
